import React from 'react';
import classes from './Showcase.css'
import Logo from '../../UI/Logo/Logo';
import Button from '../../UI/Button/Button';
import DecorativeButton from '../../UI/DecorativeButton/DecorativeButton';
import myImage from '../../../assets/img/mayank-sagar.jpg';

const showcase = () => (
    <section className={classes.Showcase} id="home">
    <div className={classes.mainGroup}>
       <div className={classes.heroImageContainer}>
            <img src={myImage} alt="Mayank Sagar" className={classes.heroImage} />
       </div>
       <h1>Mayank Sagar</h1>
       <h4>Web Devloper</h4>
    </div>
      <div className={classes.Action} >
         <DecorativeButton target="_blank" to={'https://firebasestorage.googleapis.com/v0/b/portfolio-f80c5.appspot.com/o/2026%20resume.pdf?alt=media&token=b80f13cb-9f06-4577-bd91-2b2a0213720b'}>
            <i className="fa fa-cloud-download fa-1x"></i>&nbsp;Download
         </DecorativeButton>
      </div>
   </section>
)

export default showcase;


// WEBPACK FOOTER //
// ./src/components/Sections/Showcase/Showcase.js